import React from 'react'
import { Wrapper, BackIcon, Title } from '../styles'

type Props = {
  jobName: string
  handleBack: () => void
}

function NavHeader({ jobName, handleBack }: Props) {
  return (
    <Wrapper align="center">
      <BackIcon onClick={handleBack} />
      <Title>{jobName}</Title>
    </Wrapper>
  )
}

export default NavHeader
